import React from 'react';
import './PendingInvitationCard.css';

/**
 * Renders a single pending (not-yet-accepted) organization invitation
 * scoped to a portfolio set. Unlike PortfolioUserCard, an invitee has no
 * user record yet -- there is no name, no user id, and no avatar -- so
 * this card is keyed and displayed by email instead.
 */
/**
 * Formats an invitation expiry instant as the viewer's own calendar date, or
 * 'N/A' when the invitation carries no expiry.
 *
 * The backend enforces expiry as an instant (expires_at->isPast()), not as a
 * calendar date in any zone, so the invitation stops working on the viewer's
 * local date of that instant. A date in any other zone can overstate how long
 * the invitation remains usable.
 */
const EXPIRES_AT_LOCALE = 'en-US';

const formatExpiresAt = (dateString) => {
	if (!dateString) return 'N/A';

	const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
	return new Date(dateString).toLocaleDateString(EXPIRES_AT_LOCALE, options);
};

const PendingInvitationCard = ({ invitation, onRevoke, revokeDisabled = false }) => {
	return (
		<div
			className="portfolio-user-card pending-invitation-card"
			title={invitation.email}
		>
			<div className="portfolio-user-avatar pending-invitation-avatar">
				<i className="bi bi-envelope-paper" />
			</div>
			<div className="portfolio-user-name">{invitation.email}</div>
			<div className="portfolio-user-role">{invitation.role}</div>
			<div className="portfolio-user-status">
				<span className="status-badge status-pending">
					<i className="bi bi-clock-history me-1"></i>
					Invited &middot; expires {formatExpiresAt(invitation.expiresAt)}
				</span>
			</div>
			{invitation.invitedByName && (
				<div className="portfolio-user-added-by">
					<small className="text-muted">
						<i className="bi bi-person-plus me-1"></i>
						Invited by {invitation.invitedByName}
					</small>
				</div>
			)}
			{onRevoke && (
				<div className="portfolio-user-actions mt-2">
					<button
						className="btn btn-sm btn-outline-danger"
						onClick={(e) => {
							e.stopPropagation();
							onRevoke(invitation);
						}}
						disabled={revokeDisabled}
						title={
							revokeDisabled
								? 'Revoke invitation (loading your organization...)'
								: 'Revoke invitation'
						}
					>
						<i className="bi bi-trash" />
					</button>
				</div>
			)}
		</div>
	);
};

export default PendingInvitationCard;
